import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { CardLinkAffiliatesStore, CardLinkAffiliatesState } from './card-link-affiliates.store';

@Injectable({ providedIn: 'root' })
export class CardLinkAffiliatesQuery extends QueryEntity<CardLinkAffiliatesState> {

  constructor(protected store: CardLinkAffiliatesStore) {
    super(store);
  }


}
